import { Component, Input } from '@angular/core';
import { FaqItem } from 'src/app/core/models/lead-campaign';

@Component({
  selector: 'app-faq-item',
  templateUrl: './faq-item.component.html',
  styleUrls: ['./faq-item.component.scss']
})
export class FaqItemComponent {

  @Input() public faqItem: FaqItem;

  constructor() { }

  onClick(positive: boolean): void {

    if (positive) {
      this.faqItem.wasUseful = true;
      return;
    }
    this.faqItem.wasUseful = false;
  }
}